import { render, staticRenderFns } from "./MaterialBarChartCard.vue?vue&type=template&id=e4281e9a&"
import script from "./MaterialBarChartCard.vue?vue&type=script&lang=js&"
export * from "./MaterialBarChartCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialBarChartCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports